import Config from "../../config/Config";
import axios from "axios";

const baseUrlDev = Config.BaseUrlDev;
const bearer = () => {
  return localStorage.getItem("token_redux").replaceAll('"', "");
};
export const getBalance = (token = bearer()) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}python/balance`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
